import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';
import { RopesModel } from '../../Models/MiniGames/RopesModel';

@Singleton
export class RopesLogic {
    constructor(
        @Inject private _model: RopesModel,
        @Inject private _modelEvents: ModelEvents
    ) {}

    public checkRightColors(color: string) {
        if (this._model.rightOrderColors[this._model.posInArray] === color) {
            this._model.doneCounter += 1;
            if (this._model.doneCounter === 2) {
                this._model.posInArray += 1;
                this._model.doneCounter = 0;
            }
            return true;
        } else {
            return false;
        }
    }

    public increaseRightAnswer(){
        this._model.rightAnswers++;
    }

    public increaseWrongAnswer(){
        this._model.wrongAnswers++;
    }

    public setWrongAnswer(wrong: number){
        this._model.wrongAnswers = wrong;
    }

    public increaseRoundIndex(){
        this._model.roundIndex++;
    }

    public reset(): void {
        this._model.posInArray = 0;
    }
}
